import { useEffect, useState } from "react";
import * as api from "../lib/api";

// One /admin/me request per page load, shared by the sidebar, banner and admin page.
let _check = null;

export function usePlatformAdmin() {
  const [state, setState] = useState({ loaded: false, isAdmin: false, userId: null, configured: null, error: null });
  useEffect(() => {
    if (!_check) {
      _check = api.getAdminMe()
        .then(r => ({ isAdmin: !!r.is_platform_admin, userId: r.user_id || null, configured: r.admin_ids_configured ?? null, error: null }))
        .catch(e => {
          _check = null;
          return { isAdmin: false, userId: null, configured: null, error: e.response?.status || e.message };
        });
    }
    let alive = true;
    _check.then(r => alive && setState({ loaded: true, ...r }));
    return () => { alive = false; };
  }, []);
  return state;
}
